module.exports = __webpack_public_path__ + "static/img/company-component-coveEn-10-2.5146aa1b.jpg";